import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "types/redux";

export const createInitiativeSelector = (id: string | undefined) => (state: RootState) =>
  id === undefined ? undefined : state.entities.initiatives.byId[id];

export const createInitiativesSelector = (ids: string[]) =>
  createSelector(...ids.map(createInitiativeSelector), (...initiatives) =>
    initiatives.filter((item) => item !== undefined),
  );
